export const iconFontAwesomeHouseholdPlug = (
	<i className="fa-solid fa-plug"></i>
);
